import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * The old combined guide was split into location targeting and sticky vs
 * rotating. Blog posts and external links still point here, and the link text
 * was always about the location list, so send them there.
 */
export const Route = createFileRoute('/docs/sessions-and-locations')({
  beforeLoad: () => {
    throw redirect({
      to: '/docs/$slug',
      params: { slug: 'location-targeting' },
      statusCode: 301,
    })
  },
})
